<!-- list -->
<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'NOTIFICATION.NOTIFICATION_LIST' | translate }}</div>
                <div class="tools">
                    <!-- <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> Удалить выбранное
                    </button> -->
                    <!-- toggle -->
                    <span class="switch-title"> Отправлять уведомления на почту?</span>
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="emailNotificationsState" (change)="setEmailNotificationState()">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">

                    <thead>
                        <tr>
                            <!-- <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_attr_all"
                                        id="select_attr_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_attr_all"></label>
                                </div>
                            </th> -->
                            <!-- <th scope="col" class="name">{{ 'TYPE' | translate }}</th>                           -->
                            <th scope="col" class="content">{{ 'CONTENT' | translate }}</th>
                            <th scope="col" class="date">{{ 'DATE' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="notifications && notifications.length > 0">
                        <tr *ngFor="let notification of notifications; let i = index">
                            <!-- <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_attr_all{{ i }}"
                                        id="select_attr_all{{ i }}" [checked]="attribute.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_attr_all{{ i }}"></label>
                                </div>
                            </td> -->
                            <!-- <td class="name">{{notification.notification_type_name}}</td> -->
                            <td class="content">{{ notification.title }}</td>
                            <td class="date">{{ notification.create_date | date: 'dd.MM.yyyy' }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" routerLink="/notifications/profile/{{ notification.id }}" placement="top" ngbTooltip="{{ 'WATCH' | translate }}">
                                    <i class="bi bi-eye"></i>
                                </button>
                                <!-- <button type="button" class="btn btn-light" (click)="onDelete([attribute.id])"
                                    placement="top" ngbTooltip="Удалить">
                                    <i class="bi bi bi-trash"></i>
                                </button> -->
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!notifications || notifications.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="4">
                                <div>{{ 'LOADING' | translate }}</div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="4">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>